import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-h6" }

import TimelineScorecard from '../TimelineScorecard.vue'
import { useExpenses } from '../../store/useExpenses'
import { useI18n } from 'vue-i18n'
import FormExpense from '../FormExpense.vue'
import { computed, ref } from 'vue'
import { useTimers } from '../../store/timers'
import { storeToRefs } from 'pinia'

export default /*#__PURE__*/_defineComponent({
  __name: 'TimelineScorecardExpenses',
  props: {
    date: { default: () => new Date() }
  },
  setup(__props: any) {

const props = __props

// const { getTodaysExpenses, getTodaysExpensesTotals } = storeToRefs(useExpenses())
const { isLocked } = storeToRefs(useTimers())
const { getExpensesByDate, getExpenseTotals } = useExpenses()
const { t } = useI18n({ useScope: 'global' })
const timelineLabel = (key: string) => t(`timeline.${key}`)
//Expenses
const expenseModal = ref(false)
const openExpenseModal = () => {
  if (!isLocked.value) {
    expenseModal.value = true
  }
}

const getDaysExpenses = computed(() => {
  return getExpensesByDate(props.date)
})
const getDaysExpenseTotals = computed(() => {
  return getExpenseTotals(getDaysExpenses.value)
})

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TimelineScorecard, {
      onClick: openExpenseModal,
      header: timelineLabel('expenses'),
      subheader: `${getDaysExpenseTotals.value}`
    }, null, 8, ["header", "subheader"]),
    _createVNode(_component_q_dialog, {
      modelValue: expenseModal.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((expenseModal).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, {
          style: {"min-width":"280px"},
          class: "q-pa-md"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, _toDisplayString(timelineLabel('expenses')), 1)
              ]),
              _: 1
            }),
            _createVNode(FormExpense, {
              expenses: getDaysExpenses.value,
              date: _ctx.date
            }, null, 8, ["expenses", "date"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})